import { ReactNode, useEffect, useState } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";

import {
  FILTER_TYPE,
  FILTERS_ORDER_SETTINGS_KEY,
  INTEGRATIONS_FILTERS,
  INTEGRATIONS_FILTERS_OPTIONS_MAP,
} from "../../constants";

type FiltersLayoutProps = {
  children: ReactNode;
  titleId: string;
};

const FiltersLayout = ({ children, titleId }: FiltersLayoutProps) => {
  const [loading, setLoading] = useState<boolean>(true);

  // workaround. Filters relies on an API request setting the loading state to false on
  // the second render, but we don't have an API request here.
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Filters
      filters={INTEGRATIONS_FILTERS}
      filtersItemsOptionsMap={INTEGRATIONS_FILTERS_OPTIONS_MAP}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortDirection={null}
      initialSortOption={null}
      pollActiveSections={() => undefined}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersType={FILTER_TYPE}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper titleId={titleId}>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default FiltersLayout;
